import { axios } from '@/utils/request'

export function getCarouselList (parameter) {
  return axios({
    url: '/shop/info/carousel',
    method: 'get',
    params: parameter
  })
}

export function handleDelivery (id) {
  return axios({
    url: '/ordersub/delivery',
    data: { id: id },
    method: 'post'
  })
}

export function changeDeliveryDate (subOrderId, deliveryDate, allOrder) {
  return axios({
    url: '/ordersub/change/deliveryDate/' + subOrderId,
    params: {
      deliveryDate: deliveryDate,
      allOrder: allOrder
    },
    method: 'put'
  })
}

export function updatePurchaseInfo (purchaseId, params) {
  return axios({
    url: '/purchase/adjust/' + purchaseId,
    method: 'put',
    data: params
  })
}

export function generatePurchaseOrder (purchaseDate) {
  return axios({
    url: '/stat/generate/purchase',
    params: { deliveryDate: purchaseDate },
    method: 'post'
  })
}

export function updateStockUpList (subId, params) {
  return axios({
    url: '/ordersub/stockUp/' + subId,
    data: params,
    method: 'put'
  })
}

export function getPurchaseStatistics (purchaseDate) {
  return axios({
    url: '/purchase/statistics',
    method: 'get',
    params: { deliveryDate: purchaseDate }
  })
}

export function batchChangePrice (params) {
  return axios({
    url: '/pricelog/batchChangePrice',
    data: params,
    method: 'post'
  })
}

export function syncStock (deliveryDate) {
  return axios({
    url: '/stock/sync',
    params: {
      deliveryDate: deliveryDate
    },
    method: 'put'
  })
}

export function inStock (stockId, params) {
  return axios({
    url: '/stock/in/' + stockId,
    data: params,
    method: 'post'
  })
}

export function outStock (stockId, params) {
  return axios({
    url: '/stock/out/' + stockId,
    data: params,
    method: 'put'
  })
}

export function scrapStock (stockId, params) {
  return axios({
    url: '/stock/scrap/' + stockId,
    data: params,
    method: 'put'
  })
}

export function addSupplierPurchaseRecrod (params) {
  return axios({
    url: '/platform/supplier/purchase',
    data: params,
    method: 'post'
  })
}
